export function capitalizeFirstLetter(string: string) {
  if (string === 'vat') {
    return string.toUpperCase();
  } else return string.charAt(0).toUpperCase() + string.slice(1);
}
